var map = {
	"./de/defaults.ts": [
		944,
		944
	],
	"./en/defaults.ts": [
		531,
		531
	],
	"./fr/defaults.ts": [
		9034,
		34
	],
	"./it/defaults.ts": [
		5485,
		485
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4041;
module.exports = webpackAsyncContext;